import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ConfigProvider, Switch } from 'antd';
import { useNavigate } from 'react-router-dom';
import arrowLeft from '../../../assets/image/arrowleft.png';
import timelineIcon from '../../../assets/image/timeline.png';

import { observer } from 'mobx-react';
import menuIcon from '../../../assets/image/menuIcon.png';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';
import TimelinePageStore from '../store/TimelinePageStore';

interface TopHeaderProps {
  isBackIcon?: boolean;
  isChangeIcon?: boolean;
  pageStore: TimelinePageStore;
}

function TopHeader({ isBackIcon, isChangeIcon, pageStore }: TopHeaderProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { isMobile } = useMediaQueryState();
  const handleClickArrowBtn = () => {
    navigate(-1);
  };

  const onClickChangeIcon = () => {
    pageStore.setIsChecked(!pageStore.isChecked);
  };

  return (
    <Grid container alignItems={'center'} justifyContent={'space-around'} style={{ marginTop: '30px' }}>
      <Grid style={{ marginTop: '6px', cursor: 'pointer' }}>{isMobile && isBackIcon ? <img src={arrowLeft} onClick={handleClickArrowBtn} alt='backIcon' /> : <></>}</Grid>
      <Grid>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '24px',
          }}
        >
          Timeline
        </Typography>
        {/* <HeaderTitle /> */}
      </Grid>
      <Grid>
        {isChangeIcon ? (
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#2281D0',
              },
            }}
          >
            <Switch
              checkedChildren={
                <>
                  <img src={timelineIcon} alt='timeline' />
                </>
              }
              unCheckedChildren={
                <>
                  <img src={menuIcon} alt='menuIcon' />
                </>
              }
              checked={pageStore.isChecked}
              onChange={onClickChangeIcon}
              style={{
                background: '#2281D0',
              }}
            />
          </ConfigProvider>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles({
  boxdot: {
    width: '270px',
    height: '124px',
  },
});

export default observer(TopHeader);
